import HttpCondominio from '@/typescript/servicos/http/condominio'
import HttpFastAPI from '@/typescript/servicos/http/fastapi'
import {
  HelperFolhaResposta,
  IFolhaRepositorio,
  RotaFolhaParcial,
  SubRotaFolhaParcial
} from '@/typescript/modulos/estrutura-de-pontos-da-empresa/Folha/repositorio/folha.repositorio.interface'
import {
  IRequestAcumuladoBH,
  IRequestDiasDaFolhaPorEntidade,
  IRequestFolhaParcialLoteDeLinhasEmpregado,
  IRequestFolhaParcialLoteDeLinhasGrupo,
  IRequestFolhaParcialLoteDeLinhasPorLocalDeTrabalho,
  IRequestFolhaParcialSubRotaBase,
  IRequestLoteDeJustificativasDasLinhas,
  IRequestProcessarPontos,
  IRequestVerificarDia,
  IRequestResumoBancoDeHorasPorEmpregado,
  IRequestRegerarJornadasQuePrecisam,
  IRequestGerarJornadasQueFaltam
} from '@/typescript/modulos/estrutura-de-pontos-da-empresa/Folha/repositorio/folha.respositorio.request'
import { HttpRequestConfig, IMetodoHttp, TipoRequisicaoParaRetry } from '@/typescript/servicos/http/http.interfaces'

const ESTRATEGIA_RETRY_FOLHA = [
  { tipo: TipoRequisicaoParaRetry.BASE, timeout: 50000 },
  { tipo: TipoRequisicaoParaRetry.BASE, timeout: 60000 },
  { tipo: TipoRequisicaoParaRetry.BASE, timeout: 70000 }
]

export class FolhaRepositorio implements IFolhaRepositorio {
  http: HttpCondominio
  httpFastAPI: HttpFastAPI

  constructor (http: HttpCondominio, httpFastAPI: HttpFastAPI) {
    this.http = http
    this.httpFastAPI = httpFastAPI
  }

  private montarUrlFolhaParcial (rota: SubRotaFolhaParcial): string {
    return `${RotaFolhaParcial.TimesheetPartial}/${rota}`
  }

  async obterLoteDeLinhasPorLocalDeTrabalho (data: IRequestFolhaParcialLoteDeLinhasPorLocalDeTrabalho, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaLinhasSucesso'] {
    return this.http.post(this.montarUrlFolhaParcial(SubRotaFolhaParcial.Lines), data, config)
  }

  async obterLoteDeLinhasPorEmpregado (data: IRequestFolhaParcialLoteDeLinhasEmpregado, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaLinhasSucesso'] {
    return this.http.post(this.montarUrlFolhaParcial(SubRotaFolhaParcial.Lines), data, config)
  }

  async obterLoteDeLinhasPorGrupo (data: IRequestFolhaParcialLoteDeLinhasGrupo, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaLinhasSucesso'] {
    return this.http.post(this.montarUrlFolhaParcial(SubRotaFolhaParcial.Lines), data, config)
  }

  async obterLoteDeMarcacoesDasLinhas (data: IRequestFolhaParcialSubRotaBase, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso'] {
    return this.http.post(this.montarUrlFolhaParcial(SubRotaFolhaParcial.Pts), data, config)
  }

  async obterLoteDeJornadaDiariasDasLinhas (data: IRequestFolhaParcialSubRotaBase, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso'] {
    return this.http.post(this.montarUrlFolhaParcial(SubRotaFolhaParcial.Djs), data, config)
  }

  async obterLoteDeAprovacoesDasLinhas (data: IRequestFolhaParcialSubRotaBase, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso'] {
    return this.http.post(this.montarUrlFolhaParcial(SubRotaFolhaParcial.Approvals), data, config)
  }

  async obterLoteDeBancoDeHorasDasLinhas (data: IRequestFolhaParcialSubRotaBase, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso'] {
    return this.http.post(this.montarUrlFolhaParcial(SubRotaFolhaParcial.Whbs), data, config)
  }

  async obterLoteDeJustificativasDasLinhas (data: IRequestLoteDeJustificativasDasLinhas, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSubRotaSucesso'] {
    return this.http.post(this.montarUrlFolhaParcial(SubRotaFolhaParcial.Justifies), data, config)
  }

  async obterDiasDaFolhaPorEntidade(
    data: IRequestDiasDaFolhaPorEntidade,
    config: HttpRequestConfig
  ): HelperFolhaResposta['ResponseFolhaParcialSucesso'] {
    return this.httpFastAPI.realizarRequisicaoComRetrys({
      metodo: IMetodoHttp.POST,
      endpoint: 'folha-de-ponto/dia-da-folha',
      configuracoesDeRequisicao: {
        data: data,
        ...config
      },
      configuracaoRetrys: ESTRATEGIA_RETRY_FOLHA,
      intervaloEntreRetrys: 5000
    })
  }

  async recalcularDiasQuePrecisam(data: IRequestDiasDaFolhaPorEntidade, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSucesso'] {
    return this.httpFastAPI.post('folha-de-ponto/dia-da-folha/recalcular-dias-que-precisam', data, config)
  }

  async regerarJornadasQuePrecisam(data: IRequestRegerarJornadasQuePrecisam, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSucesso'] {
    return this.httpFastAPI.post('folha-de-ponto/dia-da-folha/regerar-jornadas-que-precisam', data, config)
  }

  async gerarJornadasQueFaltam(data: IRequestGerarJornadasQueFaltam, config: HttpRequestConfig): HelperFolhaResposta['ResponseFolhaParcialSucesso'] {
    return this.httpFastAPI.post('folha-de-ponto/dia-da-folha/gerar-jornadas-que-faltam', data, config)
  }

  async processarPontosDaFolha(data: IRequestProcessarPontos, config: HttpRequestConfig): HelperFolhaResposta['ResponsePadraoFastAPI'] {
    return this.httpFastAPI.post('registros/processar_pontos_da_folha/', data, config)
  }

  async verificarDiaDafolha(data: IRequestVerificarDia, config?: HttpRequestConfig): HelperFolhaResposta['ResponsePadraoFastAPI'] {
    return this.httpFastAPI.post('folha-de-ponto/dia-da-folha/verificar-dia', data, config)
  }

  async obterAcumuladoBancoDeHoras (data: IRequestAcumuladoBH): HelperFolhaResposta['ResponseAcumuladoBH'] {
    const { empregado_id, mes, ano } = data
    return this.httpFastAPI.get(`folha-de-ponto/acumulado-de-bh/${empregado_id}/${mes}/${ano}`)
  }

  async obterResumoBancoDeHorasPorEmpregado (data: IRequestResumoBancoDeHorasPorEmpregado): HelperFolhaResposta['ResponseResumoBancoDeHorasPorEmpregado'] {
    return this.httpFastAPI.post('folha-de-ponto/banco-de-horas/resumo-por-empregado', data)
  }
}
